import { render, staticRenderFns } from "./GiftSave.vue?vue&type=template&id=aab8e2e8&scoped=true"
import script from "./GiftSave.vue?vue&type=script&lang=js"
export * from "./GiftSave.vue?vue&type=script&lang=js"
import style0 from "./GiftSave.vue?vue&type=style&index=0&id=aab8e2e8&prod&lang=css"
import style1 from "./GiftSave.vue?vue&type=style&index=1&id=aab8e2e8&prod&lang=scss&scoped=true"
import style2 from "./GiftSave.vue?vue&type=style&index=2&id=aab8e2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab8e2e8",
  null
  
)

export default component.exports